module.exports = __webpack_public_path__ + "img/29400.5ae374ed.jpg";